<template>
  <a class="default-logo"
     @click="onLogoClick">
    <img :src="logo" />
  </a>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router"
import logo from "./assets/imgs/console_logo.svg"

const router = useRouter()

const onLogoClick = () => {
  router.push("/")
}
</script>

<style scoped lang="less">
.default-logo {
  width: 26%;
  height: 45%;
  margin: 20px 0 0 20px;
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
}
</style>
